import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { Action } from '@ngrx/store';
import { filter, tap } from 'rxjs/operators';
import { ValidateJWTError } from './auth.actions';
import { ConfigManagerService } from '../../shared/services/config-manager.service';

@Injectable()
export class AuthEffects {
    constructor(
        private actions$: Actions,
        private configManagerService: ConfigManagerService
    ) {}

    @Effect({ dispatch: false })
    validateError$: Observable<Action> = this.actions$.pipe(
        filter((action: Action) => {
            return action instanceof ValidateJWTError;
        }),
        tap((action: ValidateJWTError) => {
            if (!action.payload.framed) {
                this.configManagerService.doAuthenticationRedirect(
                    action.payload.authErrorCode
                );
            }
        })
    );
}
